export const useBookingTypes = () => {
  const isExperienceFreedom = useIsExperienceFreedom();

  const bookingTypes = computed(() =>
    isExperienceFreedom.value
      ? {
          default: {
            value: "default",
            label: "Standard",
          },
          experience_freedom: {
            value: "experience_freedom",
            label: "Experience Freedom",
          },
          seasonal: {
            value: "seasonal",
            label: "Seasonal",
          },
          storage: {
            value: "storage",
            label: "Storage",
          },
          ferry: {
            value: "ferry",
            label: "Ferry",
          },
          pitchup: {
            value: "pitchup",
            label: "Pitch Up",
          },
        }
      : {
          default: {
            value: "default",
            label: "Standard",
          },
          seasonal: {
            value: "seasonal",
            label: "Seasonal",
          },
          storage: {
            value: "storage",
            label: "Storage",
          },
          ferry: {
            value: "ferry",
            label: "Ferry",
          },
          pitchup: {
            value: "pitchup",
            label: "Pitch Up",
          },
        },
  );

  return {
    data: bookingTypes,
    options: computed(() => Object.values(bookingTypes.value)),
  };
};
